export const certifications = [
  {
    id: 1,
    name: "Meta React Specialization",
    level: "Specialization",
    issuer: "Meta (via Coursera)",
    year: "2025",
    icon: "SiMeta",
    color: "#0081FB",
    credentialUrl: "https://coursera.org/verify/specialization/UHOYOA6J1LZS",
  },
  {
    id: 2,
    name: "Google IT Support",
    level: "Professional Certificate",
    issuer: "Google (via Coursera)",
    year: "2025",
    icon: "SiGoogle",
    color: "#054ADA",
    credentialUrl: "https://coursera.org/verify/professional-cert/PVU91ZGRI25Q",
  },
  {
    id: 3,
    name: "Google IT Automation with Python",
    level: "Professional Certificate",
    issuer: "Google (via Coursera)",
    year: "2023",
    icon: "SiGoogle",
    color: "#4285F4",
    credentialUrl: "https://coursera.org/verify/professional-cert/AQGM74VRSJ2C",
  },
];
